import {
  DeleteOutlined,
  EditOutlined,
  PlusCircleOutlined
} from '@ant-design/icons';
import {
  Button,
  Form,
  Input,
  message,
  Modal,
  Select,
  Space,
  Spin,
  Tooltip
} from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import ResponsiveContainer from '../../../components/ResponsiveContainer';
import TableAndFilters from '../../../components/TableAndFilters';
import { errorHandler } from '../../../utils';
import { instanceRef } from '../../../utils/axios';
import { fieldTypes } from '../../../utils/filter-utils';

const { Option } = Select;

function Marcas() {
  const tableRef = useRef();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [editData, setEditData] = useState(null);
  const [paises, setPaises] = useState([]);

  const handleClose = () => {
    setEditData(null);
    setIsModalOpen(false);
  };

  const getPaises = async () => {
    setLoading(true);
    try {
      const response = await instanceRef.instance.get('/pais');
      setPaises(response.data.data);
      setLoading(false);
    } catch (error) {
      errorHandler(error);
    } finally {
      setLoading(false);
    }
  };

  const verificarDescripcion = async (value) => {
    try {
      const response = await instanceRef.instance.post('/marca/descripcion', {
        params: { descripcion: value }
      });
      if (response.data?.data?.existe) {
        throw new Error('La Marca ya existe!');
      }
    } catch (err) {
      throw new Error(err.message || 'Error validando la marca');
    }
    return Promise.resolve();
  };

  const handleFormSubmit = async (values) => {
    setLoading(true);
    try {
      const url = editData ? '/marca/update' : '/marca/add';
      await instanceRef.instance.post(url, { marca: values });
      message.success('Guardado exitosamente!');
      tableRef.current.reload();
      form.resetFields();
      setEditData(null);
    } catch (error) {
      errorHandler(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getPaises();
  }, []);

  const ModalCrearMarca = () => {
    return (
      <Modal
        title="Agregar Marca"
        open={isModalOpen}
        onCancel={handleClose}
        footer={
          <Button
            type="primary"
            onClick={() => {
              form.validateFields().then((values) => {
                handleFormSubmit(values);
                handleClose();
              });
            }}
          >
            Guardar
          </Button>
        }
      >
        <Spin spinning={loading} size="large" tip="Cargando...">
          <Form form={form} layout="vertical">
            <Form.Item name="codigo" label="" style={{ display: 'none' }}>
              <Input />
            </Form.Item>
            <Form.Item
              name="descripcion"
              label="Descripción"
              rules={[
                { required: true, message: 'Este campo es requerido' },
                {
                  validator: async (_, value) => {
                    if (!value) return Promise.resolve();
                    return verificarDescripcion(value);
                  }
                }
              ]}
            >
              <Input
                onChange={(e) => {
                  const descripcion = e.target.value.toUpperCase();
                  form.setFieldsValue({ descripcion });
                  form.validateFields(['descripcion']);
                }}
              />
            </Form.Item>
            <Form.Item
              name="pais"
              label="País"
              rules={[{ required: true, message: 'Este campo es requerido' }]}
            >
              <Select
                showSearch
                allowClear
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                style={{ width: '100%' }}
                optionFilterProp="children"
                placeholder="Seleccionar Pais"
                loading={loading}
              >
                {paises.map((item) => (
                  <Option key={`${item.codigo}`} value={`${item.descripcion}`}>
                    {`${item.codigo.toUpperCase()} - ${item.descripcion.toUpperCase()}`}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Form>
        </Spin>
      </Modal>
    );
  };

  const columnas = [
    {
      title: 'Código',
      dataIndex: ['codigo']
    },
    {
      title: 'Descripción',
      dataIndex: ['descripcion'],
      filterType: fieldTypes.STRING
    },
    {
      title: 'Pais',
      dataIndex: ['pais'],
      filterType: fieldTypes.STRING
    },
    {
      title: 'Acciones',
      key: 'acciones',
      render: (record) => {
        return (
          <Space>
            <Tooltip title="Editar">
              <Button
                type="text"
                icon={<EditOutlined />}
                size="middle"
                onClick={() => {
                  form.setFieldsValue({
                    codigo: record.codigo,
                    pais: record.pais.toLowerCase(),
                    descripcion: record.descripcion
                  });
                  setEditData(true);
                  setIsModalOpen(true);
                }}
              />
            </Tooltip>
            <Tooltip title="Eliminar">
              <DeleteOutlined style={{ color: 'rgba(0,0,0,.45)' }} disabled />
            </Tooltip>
          </Space>
        );
      }
    }
  ];

  return (
    <ResponsiveContainer size="large" style={{ paddingTop: 0 }}>
      <TableAndFilters
        ref={tableRef}
        withGeneralFilter
        url="/marca"
        title={`
             Gestión de Marcas`}
        columns={columnas}
        showTable
        hasExportar
        extra={[
          <Button
            key="agregarMarca"
            type="dashed"
            shape="round"
            icon={<PlusCircleOutlined />}
            size="middle"
            onClick={() => {
              form.resetFields();
              setIsModalOpen(true);
            }}
          >
            Agregar Marca
          </Button>
        ]}
      />
      <ModalCrearMarca />
    </ResponsiveContainer>
  );
}

export default Marcas;
